import { StoreImageEnum as r } from "../../../enums/store-image-enum.mjs";
import { ProductTypeEnum as t } from "../enums/product-type-enum.mjs";
const a = (e) => {
  switch (e) {
    case t.download:
      return r.product_download_thumbnail;
    case t.eCourse:
      return r.e_course_thumbnail;
    case t.physicalProduct:
      return r.physical_product_thumbnail;
  }
};
export {
  a as getDefaultImageByProductType
};
